import { Component, OnInit, ContentChild, NgModule } from '@angular/core';
import { NgbActiveModal, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ReceivedCase, RepairshopCaseService } from '../../../api';
import { CustomdatepickerComponent } from '../../../../shared/modules/customdatepicker.component';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../../../shared/service/toast.service';
import { PaymentComponent } from '../payment/payment.component';
import { compressImage } from '../../../../shared/service/image.service';

@Component({
  selector: 'app-receive',
  templateUrl: './receive.component.html',
  styleUrls: ['./receive.component.scss']
})
export class ReceiveComponent implements OnInit {
  @ContentChild(CustomdatepickerComponent) datepickerViewChild: CustomdatepickerComponent;
  caseId = null;
  PhotoUrl = '';
  data: ReceivedCase;
  today = new Date();
  bike;
  status;
  received;
  photo;
  receiveForm: FormGroup;
  loading = false;
  minDate = { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() };
  maxDate = { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() };
  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private translate: TranslateService,
    private toast: ToastService,
    private rs: RepairshopCaseService
  ) { }

  ngOnInit() {
    let dt = new Date();
    if (this.received) {
      // receivedDate = 0 nghĩa là chưa có ngày nhận. Nhân 1000 sẽ ra 01/01/1970,
      // form điền sẵn mốc đó rồi bấm lưu là ghi ngược 1970 trở lại DB - lỗi tự nuôi
      // chính nó. Giữ mặc định là thời điểm hiện tại thay vì mốc epoch.
      if (this.received.receivedDate > 0) {
        dt = new Date(this.received.receivedDate * 1000);
      }
      if (this.received.photos.length) {
        this.PhotoUrl = this.received.photos[0];
      }
    }
    const date = {
      'year': dt.getFullYear(),
      'month': dt.getMonth() + 1,
      'day': dt.getDate()
    };
    const time = {
      'hour': dt.getHours(),
      'minute': dt.getMinutes()
    };
    this.receiveForm = new FormGroup({
      note: new FormControl(),
      email: new FormControl(true),
      time: new FormControl(time),
      date: new FormControl(date),
      name: new FormControl(null, [
        Validators.required
      ])
    }, validateReceive);
    if (this.received) {
      this.note.setValue(this.received.note);
      this.name.setValue(this.received.receivedBy);
    } else {
      this.name.setValue(JSON.parse(localStorage.getItem('currentUser')).name);
    }
    console.log(this.received)
  }
  get note() { return this.receiveForm.get('note'); }
  get time() { return this.receiveForm.get('time'); }
  get date() { return this.receiveForm.get('date'); }
  get email() { return this.receiveForm.get('email'); }
  get name() { return this.receiveForm.get('name'); }
  handleInputChange(e) {
    const file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    const pattern = 'image/jpeg|image/jpg|image/png|image/gif';
    const reader = new FileReader();
    if (!file.type.match(pattern) || file.size > (5 * 1024 * 1024)) {
      this.toast.showError(this.translate.instant('INVALID_IMAGE'));
      return;
    }
    // Ảnh lúc nhận xe được nhúng vào email báo giá, nên giữ JPEG đã thu nhỏ.
    compressImage(file, 'jpeg').then(compressed => {
      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsDataURL(compressed);
    });
  }
  _handleReaderLoaded(e) {
    const reader = e.target;
    this.PhotoUrl = reader.result;
    this.photo = reader.result.split(',').pop();
  }
  print() {
    if (!this.loading) {
      this.loading = true;
      this.rs.apiRepairshopCasesReceiptPrintByCaseIdPut(this.caseId)
        .subscribe(data => {
          this.loading = false;
          const modalRef = this.modalService.open(PaymentComponent, { size: 'lg', backdrop: 'static', centered: true });
          modalRef.componentInstance.content = data.receiptUrl;
          modalRef.result.then((result) => {
          }).catch((error) => {
          });
        });
    }
  }
  closeModal() {
    this.activeModal.dismiss('close');
  }
  saveModal() {
    if (this.receiveForm.valid) {
      const now = new Date();
      const currentMinute = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        now.getHours(),
        now.getMinutes(),
        59,
        999
      );
      const date = new Date(this.date.value.year, this.date.value.month - 1, this.date.value.day,
        this.time.value.hour, this.time.value.minute);
      if (date.getTime() > currentMinute.getTime()) {
        this.toast.showError(this.translate.instant('TIME_CANNOT_BE_IN_FUTURE'));
        return;
      }
      const data = {
        receivedDateTime: Math.floor(date.getTime() / 1000),
        note: this.note.value,
        photos: this.photo ? [this.photo] : (this.PhotoUrl.length ? [this.PhotoUrl] : []),
        email: this.email.value ? true : false,
        receivedBy: this.name.value
      };
      this.activeModal.close(data);
    }
  }
}

function validateReceive(receiveForm: FormGroup): { [key: string]: boolean } | null {
  const dateControl = receiveForm.get('date');
  const timeControl = receiveForm.get('time');
  const date = dateControl ? dateControl.value : null;
  const time = timeControl ? timeControl.value : null;
  if (!date || !time || time.hour == null || time.minute == null || !date.year || !date.month || !date.day) {
    return null;
  }
  const now = new Date();
  const currentMinute = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    now.getHours(),
    now.getMinutes(),
    59,
    999
  );
  const selectedDate = new Date(
    Number(date.year),
    Number(date.month) - 1,
    Number(date.day),
    Number(time.hour),
    Number(time.minute),
    0,
    0
  );
  if (selectedDate.getTime() > currentMinute.getTime()) {
    return { invalidFutureTime: true };
  }
  return null;
}
